module.exports = __webpack_public_path__ + "static/media/loader-car.4f5fbc2c.gif";